<template>
  <div class="login h-95">
    <AboutModal />
    <div class="background"></div>
    <a-row type="flex" class="h-100" justify="center" align="middle">
      <a-col :xl="6" :lg="8" :md="10" :sm="12" :xs="15">
        <a-form
          :form="form"
          class="login-form"
          @submit.prevent="handleSubmit">
          <h1 class="login-header text-center">Journal de travail</h1>
          <a-form-item>
            <a-input
              class="login-input"
              auto-focus
              v-decorator="[
                'login',
                { rules: [{ required: true, message: 'Veuillez entrer votre nom d\'utilisateur' }] },
              ]"
              placeholder="Nom d'utilisateur">
              <a-icon
                slot="prefix"
                type="user"
                style="color: rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'password',
                { rules: [{ required: true, message: 'Veuillez entrer votre mot de passe' }] }
              ]"
              type="password"
              placeholder="Mot de passe"
            >
              <a-icon
                slot="prefix"
                type="lock"
                style="color: rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button
              :loading="loading"
              type="primary"
              html-type="submit"
              class="login-form-button" block>
              Se connecter</a-button>
          </a-form-item>
          <a-tooltip placement="top" >
            <template slot="title">
              <span>À propos</span>
            </template>
            <a-icon class="about-icon" @click="handleAboutBtnClick()" type="info-circle" />
          </a-tooltip>
        </a-form>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AuthService from '../services/auth_service'
import AboutModal from '@/components/modal/AboutModal.vue'

export default {
  name: 'Login',
  components: {
    AboutModal
  },
  data () {
    return {
      form: this.$form.createForm(this),
      loading: false
    }
  },
  methods: {
    ...mapActions({
      'setUser': 'auth/setUser',
      'setUserToken': 'auth/setUserToken',
      'setUserFromToken': 'auth/setUserFromToken',
      'toggleAboutModalVisible': 'modal/toggleAboutModalVisible'
    }),
    handleSubmit (e) {
      this.form.validateFields(async (err, values) => {
        // Les champs ont bien été remplis
        if (!err) {
          this.loading = true
          const response = await AuthService.authenticate(values.login, values.password)
          if (response) {
            this.$message.success('Authentification réussie')
            const data = response.data.data
            // Set refreshToken dans localstorage
            localStorage.setItem('refreshToken', data.refresh_token)
            // Peupler user avec les information codée du token
            this.setUserFromToken(data.access_token)
            const token = {
              accessToken: data.access_token,
              expiresIn: data.expires_in
            }
            this.setUserToken(token)
            this.$router.push('/works')
          } else {
            this.loading = false
            this.form.setFieldsValue({
              password: ''
            })
            document.getElementById('password').focus()
          }
        }
      })
    },
    handleAboutBtnClick () {
      console.log('about')
      this.toggleAboutModalVisible()
    }
  },
  created () {
    document.title = 'JT - Se connecter'
  }
}
</script>

<style scoped lang="scss">
.about-icon{
  margin-left: 47%;
  cursor: pointer;
}
.background{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-image: url("../assets/background.png");
  background-position: 50% 0;
}
.footer {
  background: none;
}
.login-header {
  font-size: 35px;
  margin-bottom: 25px;
  font-weight: bold;
  color: #fff;
}
.login-form {
  background-color: #0c0e2d;
  border-radius: 4px;
  padding: 25px;
}
svg{
  color: white;
  font-size: 20px;
}
</style>
